import { CloudOff } from 'lucide-react';

import React from 'react';

import { useTranslation } from '@splitfiesta/i18n';

interface ExpenseReceiptOfflineNoticeProps {
  'data-testid'?: string;
}

/**
 * Friendly notice shown when user is offline and cannot upload receipt photos.
 * Explains that they can add the photo later when back online.
 */
export const ExpenseReceiptOfflineNotice: React.FC<
  ExpenseReceiptOfflineNoticeProps
> = ({ 'data-testid': dataTestId }) => {
  const { t } = useTranslation();

  return (
    <div data-testid={dataTestId}>
      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
        {t('expenses:photo.receipt')}
        <span className="ml-1 text-gray-400 dark:text-gray-500 font-normal">
          ({t('common:forms.optional')})
        </span>
      </label>

      <div className="border-2 border-dashed border-gray-200 dark:border-gray-700 rounded-lg p-4 bg-gray-50 dark:bg-gray-800/50">
        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0">
            <CloudOff className="h-5 w-5 text-gray-400 dark:text-gray-500" />
          </div>
          <div className="text-sm">
            <p className="font-medium text-gray-600 dark:text-gray-400">
              {t('expenses:photo.offlineTitle')}
            </p>
            <p className="text-gray-500 dark:text-gray-500 mt-0.5">
              {t('expenses:photo.offlineHint')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
